import type { AreaCatalog } from '../area';
import type { pickers as en } from '../en/pickers';

export const pickers = {
  'pickers.entity.placeholder': 'Personen und Gruppen suchen…',
  'pickers.entity.label': 'Personen und Gruppen zum Hinzufügen suchen',
  'pickers.entity.empty': 'Keine Treffer.',
  'pickers.field.placeholder': 'Beliebig',
  'pickers.field.clear': '{label} leeren',
  'pickers.tag.label': 'Tag suchen oder erstellen',
  'pickers.tag.placeholder': 'Tag suchen oder erstellen…',
  'pickers.tag.list': 'Tags',
  'pickers.tag.loading': 'Tags werden geladen…',
  'pickers.tag.empty': 'Tag eingeben.',
  'pickers.tag.create': '#{tag} erstellen',
  'pickers.tag.onItems': { one: 'an {count} Aufgabe', other: 'an {count} Aufgaben' },
  'pickers.tag.withTeams': { one: '{items} · {count} Gruppe', other: '{items} · {count} Gruppen' },
} as const satisfies AreaCatalog<typeof en>;
